import React, { Component } from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import '../../style/header.css';
import '../../style/generic.css';
import '../../style/popup.css';
import logo from '../../images/logoShare.png';
import homeIcon from '../../images/home-icon.png';
import categoryIcon from '../../images/category-icon.png';
import searchIcon from '../../images/search-icon.png';
import arrowIcon from '../../images/weui_arrow-filled.png';
import closeMenu from '../../images/mingcute_close-fill.png';
import axios from "axios";
import * as Constanti from '../../Utils/constants.js';

import { motion, AnimatePresence } from 'framer-motion';
import CardTwo from "../cards/cardTwo.js";
import CardThree from "../cards/cardThree.js";

class HeaderShare extends Component{
  constructor(props) {
    super(props);
    
  }
 



  render(){
    return (
    <>
    <nav className={"navbarShare "}>
    <div className="container">
        <div className="flex horizontal navContent padding-top-16 align-center">
        <div className="logo-container">
        <Link to="/"><img src={logo} width={88} alt className="logoSidebar"/></Link>
        </div>
        <div className="right-link align-center flex horizontal gap-40">
        <div className="flex horizontal align-center gap-8"> 
        <Link to="https://www.alis.it/alis-app/" target="_blank">ALIS app</Link>
        </div>
        <div className="flex horizontal align-center gap-8"> 
        <Link to="/">ALIS channel</Link>
        </div>
        <div className="flex horizontal align-center gap-8"> 
        <Link  to="https://magazine.alischannel.it/" target="_blank">ALIS magazine</Link>
        </div>
                
        </div>
        </div>
    </div>
    </nav>
</>
    )
}
}

export default HeaderShare; 